module.exports = __webpack_public_path__ + "img/brt_repanse_de_lyonesse_0.43fab992.png";